export enum FiatMethods {
  WIRE = 'WIRE',
  CARD = 'CARD',
  CASH = 'CASH',
  SEPA = 'SEPA',
  DIGITALPAY = 'DIGITALPAY',
}
